<template>
  <div class="tab-content scrollbar is-scrollable">
    <section class="detail-section">
      <div class="item-info">
        <div class="item-id">
          {{ audienceInfo.id }}
        </div>
        <div class="item-value">
          <div
            class="item-status"
            :title="audienceInfo.status"
            :class="itemCssClasses(audienceInfo.status)"
          />
          <div class="audience-label item-label">
            <p class="is-truncate" :title="audienceInfo.label">
              {{ audienceInfo.label }}
            </p>
          </div>
        </div>
      </div>
      <div class="sub-header l-flex-row--between">
        <div class="sub-header-title">
          Details
        </div>
      </div>
      <div class="info-content">
        <!-- TYPE -->
        <div class="info-block">
          <div class="label">
            Type
          </div>
          <div class="value l-flex-row l-align-center">
            {{ audienceInfo.type === 'cclones'
              ? 'Cclone'
              : audienceInfo.type === 'georadar'
                ? 'Georadar'
                : 'Audience' }}
          </div>
        </div>
        <div
          class="info-block"
          v-if="audienceInfo.type === 'cclones'"
        >
          <div class="label">
            CcloneID
          </div>

          <div
            class="info-block-ccloneid l-flex-row l-align-center"
            :class="classInfoBlockCcloneid"
            title="go to builder cclone"
            @click="RedirectToBuilder(audienceInfo.strong_classifiers_family_id)"
          >
            <div class="value">
              {{ audienceInfo.strong_classifiers_family_id }}
            </div>

            <svg-icon
              v-if="hasUserAccessToCclone"
              name="go"
              size="small"
            />
          </div>
        </div>
        <div class="info-block">
          <div class="label">
            Date
          </div>

          <div class="info-block-date l-flex-row l-align-center">
            <div class="date-start">
              {{ audienceInfo.createdAt }}
            </div>
            <svg-icon class="date-separator" name="arrow-direction_right" size="small" />
            <div class="date-end">
              {{ audienceInfo.endDate }}
            </div>
          </div>
        </div>
        <div class="info-block">
          <div class="label">
            Bootstrap
          </div>
          <div class="value l-flex-row l-align-center" style="text-transform: capitalize;">
            {{ audienceInfo.bootstrap }}
          </div>
        </div>
      </div>
    </section>
    <section class="detail-section">
      <div
        class="sub-header l-flex-row--between"
        @click="toggleSection('showSummary')"
      >
        <div
          class="sub-header-title cursor l-flex-row l-align-center"
          :class="toggleSummarySection"
        >
          <svg-icon class="mg-r-4" name="arrow_bottom" size="small" />
          Summary
        </div>
      </div>

      <transition name="slide-fade">
        <Summary
          v-show="showSummary"
          parent="monitoring"
          :summary="audienceSummary"
        />
      </transition>
    </section>
  </div>
</template>
<script>
import { isEmpty, xor } from 'lodash'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import Summary from '@/components/common/Summary'

export default {
    components: {
        Summary
    },
    props: {
        audienceInfo: { type: Object, required: false, default: () => ({}) }
    },
    data() {
        return {
            showSummaryFor: []
        }
    },
    computed: {
        ...mapState('account', {
            accountId: state => state.accountId
        }),
        ...mapState('data/cclone', {
            ccloneList: state => state.list
        }),
        ...mapGetters('account', ['getUserAccess', 'getIsMonitoringActionAllowed', 'getAccessToCclone']),

        hasUserAccessToCclone() {
            return this.getAccessToCclone()
        },
        monitoringActionAllowed() {
            return this.getIsMonitoringActionAllowed()
        },
        classInfoBlockCcloneid() {
            return this.hasUserAccessToCclone ? 'info-block-ccloneid_lk' : 'info-block-ccloneid'
        },
        audienceInfoCc() {
            return isEmpty(this.audienceInfo.cc) ? [] : this.audienceInfo.cc.split(',')
        },
        isFooter() {
            return this.activeTab === 'audience' && this.monitoringActionAllowed
        },
        showSummary() {
            return this.showSummaryFor.includes(this.audienceInfo.id)
        },
        toggleSummarySection() {
            return this.getToggleClass(this.showSummary)
        },
        audienceSummary() {
            return this.audienceInfo.summary
        },

    },
    watch: {
        showSummary: {
            handler(newValue) {
                if (newValue && this.audienceInfo && isEmpty(this.audienceInfo.summary)) {
                    this.handleRetrieveAudienceSummary()
                }
            }
        },
    },
    methods: {
        ...mapMutations('ui/cclone', ['setSelectedCclone']),
        ...mapMutations('notifications', ['setAddedNotification']),
        ...mapActions('data/cclone', ['retrieveCcloneDetails']),
        ...mapActions('data/audience', ['retrieveAudienceInfos']),

        itemCssClasses(element) {
            let cssClasses = ''
            if (element === 'inactive') cssClasses += ' is-inactive'
            if (element === 'active') cssClasses += ' is-active'

            return cssClasses
        },
        RedirectToBuilder(ccloneId) {
            if (this.hasUserAccessToCclone) {
                const isCcloneAvailable = find(this.ccloneList, cclone => cclone.id === ccloneId)
                // We only target cclones that have not been deleted
                if (isCcloneAvailable) {
                    this.setSelectedCclone({ id: ccloneId })
                    this.retrieveCcloneDetails({ ccloneId })
                } else {
                    this.setAddedNotification({ type: 'error', message: 'This Cclone does not exists anymore' })
                    this.setSelectedCclone({ id: null })
                }
                this.$router.push({ path: '/' + this.accountId + '/builder/cclone' })
            } else return false
        },
        hasUserAccessToMonitoring() {
            return this.getAccessToMonitoring()
        },
        handleRetrieveAudienceSummary() {
            this.retrieveAudienceInfos({
                type: 'summary',
                audienceId: this.audienceInfo.id,
                formula: this.audienceInfo.formula
            })
        },
        getToggleClass(expanded) {
            return expanded ? 'is-expanded' : 'is-collapsed'
        },
        toggleSection(sectionStateKey) {
            const stateKey = `${sectionStateKey}For`
            this[stateKey] = xor(this[stateKey], [this.audienceInfo.id])
        },
    }
}
</script>
